<template>
  <div>
    <Layout
      :fields="fields"
      :data="data"
      :title="`OFX: ${bank}`"
      @delete-file="deleteFile"
      @finish-update="$emit('finish-update')"
    />
  </div>
</template>

<script>
import Layout from './Layout/Layout.vue';

import ConciliationOfxService from '@/service/conciliation/ofx';

export default {
    components: {
        Layout,
    },

    props: {
        data: {
            type: Object,
            default: () => ({ data: [] }),
        },

        bank: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            fields: [
                { key: 'confirm', label: '' },
                { key: 'date', label: 'Lançamento' },
                { key: 'description', label: 'Descrição' },
                { key: 'value', label: 'Valor' },
                { key: 'departmentName', label: 'departamento' },
            ],
        };
    },

    methods: {
        async deleteFile(fileId) {
            const isConfirmed = await this.confirmAnAction('Deseja realmente apagar o arquivo?');

            if (!isConfirmed) return;

            const { status } = await ConciliationOfxService.deleteFile(fileId);

            this.$emit('deleted-file', status === 200);
        },
    },
};
</script>
